import { CommonUIService } from 'src/app/sections/common/services/common.ui.service';
import { Component, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { Town } from 'src/app/models/doctor/doctor-town.model';
import { FormGroup, UntypedFormBuilder, Validators, UntypedFormControl } from '@angular/forms';
import { TownTableService } from '../services/town-table.service';
import { TranslateService } from '@ngx-translate/core';

import { AuxillaryService } from 'src/app/sections/common/services/auxillary.service';
import { Country } from 'src/app/models/country.model';
import { Province } from 'src/app/models/doctor/province.model';
import { ProvinceEndPoints, CountryEndPoints } from 'src/app/constants/api-endpoints';
import { SortList } from 'src/app/sections/common/sortList';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-edit-town-table',
  templateUrl: './edit-town-table.component.html',
  styleUrls: ['./edit-town-table.component.scss']
})
export class EditTownTableComponent implements OnInit {

  @ViewChild('modalLargeNew', { static: false }) child;
  @Output() close: EventEmitter<any> = new EventEmitter();

  public provinceUrl = ProvinceEndPoints.getProvinceSearchData;
  public searchProvince = '';

  public countryUrl = CountryEndPoints.getCountrySearchData;
  public searchCountry = '';

  submitted = false;
  town: Town;
  townForm: FormGroup;
  isEdit: boolean;
  isLoading = false;
  selectProvinceId: number;
  selectCountryId: number;
  provinceList: Province[] = [];
  countryList: Country[] = [];
  provinceControl = new UntypedFormControl();
  countryControl = new UntypedFormControl();


  validationMessages = {  }

  constructor(private formBuilder: UntypedFormBuilder, private townTableService: TownTableService, private toastService: ToastrService,
    private translationService: TranslateService, private auxillaryService: AuxillaryService,private commonUIService : CommonUIService) {
    this.town = new Town();
    this.town.country = new Country();
    this.town.province = new Province();
  }

  ngOnInit() {
    this.getProvinceList();
    this.getCountryList();
    this.checkIfEditOrAdd();
  }

  public show(townData): void {
    this.child.show();
    this.getProvinceList();
    this.getCountryList();
    this.submitted = false;
    this.isLoading = false;
    this.town.id = townData.id;
    this.town.townName = townData.townName;
    this.town.provinceId = townData.provinceId;
    this.town.countryId = townData.countryId;
    this.town.province.provinceName = townData.provinceName;
    this.town.province.id = townData.provinceId;
    this.town.country.countryName = townData.countryName;
    this.town.country.id = townData.countryId;
    this.town.status = townData.status;
    this.townForm.reset();
    this.checkIfEditOrAdd();
  }

  getProvinceList() {
    this.isLoading = false;
    this.auxillaryService.getProvinceList().subscribe(
      (data: any) => {
        if (data._data != null) {
          this.provinceList = SortList(data._data, 'provinceName');
          this.isLoading = true;
        }
      },
      (error) => {
        this.failToast(error._message);
      }
    );
  }

  getCountryList() {
    this.isLoading = true;
    this.auxillaryService.getCountryList().subscribe(
      (data: any) => {
        if (data._data != null) {
          this.countryList = SortList(data._data, 'countryName');
          this.isLoading = false;
        }
      },
      (error) => {
        this.failToast(error._message);
      }
    );
  }

  checkIfEditOrAdd() {
    if (!this.town.id) {
      this.initializeForAddTown();
      this.isEdit = false;
      return;
    }
    this.isEdit = true;
    this.searchProvince = this.town.province.provinceName;
    this.selectProvinceId = this.town.provinceId;
    this.searchCountry = this.town.country.countryName;
    this.selectCountryId = this.town.countryId;
    this.initializeForEditTown();
  }

  initializeForAddTown() {
    this.townForm = this.formBuilder.group({
      id: [''],
      townName: ['', [Validators.required]],
      provinceId: ['', [Validators.required]],
      countryId: ['', [Validators.required]]
    });
    this.provinceControl.setValue(null);
    this.countryControl.setValue(null);
  }

  initializeForEditTown() {
    this.townForm = this.formBuilder.group({
      id: [this.town.id],
      townName: [this.town.townName, [Validators.required]],
      provinceId: [this.town.province? this.town.province.id : null, [Validators.required]],
      countryId: [this.town.country? this.town.country.id : null, [Validators.required]]
    });

    this.provinceControl.setValue(this.town.province? this.town.province.provinceName : null);
    this.countryControl.setValue(this.town.country? this.town.country.countryName : null);
  }

  onSave() {
    this.submitted = true;
    if (!this.selectProvinceId) this.townForm.controls.provinceId.setValue(null);
    if (!this.selectCountryId) this.townForm.controls.countryId.setValue(null);
    if (!this.commonUIService.validateForm(this.townForm, this.validationMessages)) {
      return;
    }
    if (this.isEdit) {
      this.updateTown(this.townForm.value);
      return;
    }
    this.saveTown(this.townForm.value);
  }

  private returnResponse(town) {
    this.close.emit(town);
    this.child.hide();
    this.isLoading = false;
  }

  saveTown(town: Town) {
    town.id = 0;
    town.status = true;
    town.provinceId = this.selectProvinceId;
    town.countryId = this.selectCountryId;
    this.isLoading = true;
    this.townTableService.saveTown(town).subscribe(
      (_data: any) => {
        this.successToast('saveTown');
        this.returnResponse(_data._data);
        this.selectCountryId = null;
        this.selectProvinceId = null;
      },
      (error) => {
        this.failToast(error._message);
      }
    );
  }

  updateTown(town: Town) {
    town.id = this.town.id;
    town.status = this.town.status;
    town.provinceId = this.selectProvinceId;
    town.countryId = this.selectCountryId;
    this.isLoading = true;
    this.townTableService.updateTown(town.id, town).subscribe(
      (_data: any) => {
        this.successToast('updateTown');
        this.returnResponse(_data._data);
        this.selectCountryId = null;
        this.selectProvinceId = null;
      },
      (error) => {
        this.failToast(error._message);
      }
    );
  }

  successToast(messageTranslationKey) {
    this.translationService.get(['success', messageTranslationKey]).subscribe((translations: any) => {
      this.toastService.success(translations[messageTranslationKey], translations.success, {
        timeOut: 5000,
        progressBar: true,
        closeButton: true,
        progressAnimation: 'increasing',
        positionClass: 'toast-bottom-right', // Adjust the position as needed
      });
    });
  }

  failToast(message) {
    this.translationService.get(['errorTitle', message]).subscribe((translations: any) => {
      this.toastService.error(translations[message], translations.success, {
        timeOut: 5000,
        progressBar: true,
        closeButton: true,
        progressAnimation: 'increasing',
        positionClass: 'toast-bottom-right', // Adjust the position as needed
      });
    });
  }

  get townName() {
    return this.townForm.get('townName');
  }

  get provinceId() {
    return this.townForm.get('provinceId');
  }

  get countryId() {
    return this.townForm.get('countryId');
  }

  isProvinceValueSelected(isValueSelected : any){
    if(isValueSelected=='empty') {
      this.townForm.controls.provinceId.setValue(null);
    }
    //value recieved, form group and control name
    this.commonUIService.novasearchDropDownValidator(isValueSelected,  this.townForm, 'provinceId');
  }

  onClearProvince() {
    this.provinceControl.setValue(null);
    this.townForm.controls.provinceId.setValue(null);
    this.selectProvinceId=null;
    this.searchProvince=null;
  }

  isCountryValueSelected(isValueSelected : any){
    if(isValueSelected=='empty') {
      this.townForm.controls.countryId.setValue(null);
    }
    //value recieved, form group and control name
    this.commonUIService.novasearchDropDownValidator(isValueSelected,  this.townForm, 'countryId');
  }

  onClearCountry() {
    this.countryControl.setValue(null);
    this.townForm.controls.countryId.setValue(null);
    this.selectCountryId=null;
    this.searchCountry=null;
  }

  onSelectProvince(result) {
    if (result) {
      this.searchProvince = '';
      this.searchProvince = result.provinceName;
      this.selectProvinceId = result.id;
    }
  }

  onSelectCountry(result) {
    if (result) {
      this.searchCountry = '';
      this.searchCountry = result.countryName;
      this.selectCountryId = result.id;
    }
  }
}
